import React from "react";
import "./App.scss";

import Display from "./components/display/display";

function App() {
  return (
    <main className="App">
      <section className="page">
        <h1>Fizz Buzz</h1>
        <Display />
        <p className="creator">
          Aaron Middleton | WNM 820 OL1: Technical Implementation
        </p>
      </section>
    </main>
  );
}

export default App;
